import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a18] via-[#0d0d24] to-[#0a0a18]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a18]/90 backdrop-blur-sm border-b border-[#1a1a3a]">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/images/dartsScheduler-trn.png" alt="Darts Scheduler" className="h-8" />
          </Link>
          <Link to="/" className="text-gray-400 hover:text-white transition-colors">
            Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="card">
            <h1 className="text-3xl font-bold text-white mb-2">Terms of Service</h1>
            <p className="text-gray-500 mb-8">Last updated: January 2025</p>

            <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
              <section>
                <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
                <p>
                  By accessing or using Darts Scheduler ("the Service"), you agree to be bound by these Terms of Service.
                  If you do not agree to these terms, please do not use the Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">2. Description of Service</h2>
                <p>
                  Darts Scheduler is an online platform that helps darts players schedule and manage their online matches.
                  The Service includes features such as availability scheduling, booking links, game tracking, and player profiles.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">3. User Accounts</h2>
                <p>
                  To use certain features of the Service, you must create an account. You are responsible for:
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Maintaining the confidentiality of your account credentials</li>
                  <li>All activities that occur under your account</li>
                  <li>Providing accurate and complete information</li>
                  <li>Notifying us immediately of any unauthorized use</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">4. Acceptable Use</h2>
                <p>You agree not to:</p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Use the Service for any illegal purpose</li>
                  <li>Harass, abuse, or harm other users</li>
                  <li>Impersonate any person or entity</li>
                  <li>Interfere with or disrupt the Service</li>
                  <li>Attempt to gain unauthorized access to any part of the Service</li>
                  <li>Use automated systems to access the Service without permission</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">5. Subscriptions and Payments</h2>
                <p>
                  Some features require a paid subscription. By subscribing, you agree to pay the fees indicated.
                  Subscriptions automatically renew unless cancelled before the renewal date.
                  Refunds are handled on a case-by-case basis.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">6. Intellectual Property</h2>
                <p>
                  The Service and its original content, features, and functionality are owned by Darts Scheduler
                  and are protected by international copyright, trademark, and other intellectual property laws.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">7. User Content</h2>
                <p>
                  You retain ownership of content you submit to the Service. By submitting content, you grant us
                  a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content
                  in connection with the Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">8. Disclaimer of Warranties</h2>
                <p>
                  The Service is provided "as is" without warranties of any kind. We do not guarantee that the
                  Service will be uninterrupted, secure, or error-free.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">9. Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, Darts Scheduler shall not be liable for any indirect,
                  incidental, special, consequential, or punitive damages resulting from your use of the Service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">10. Changes to Terms</h2>
                <p>
                  We reserve the right to modify these terms at any time. We will notify users of significant
                  changes via email or through the Service. Continued use after changes constitutes acceptance
                  of the new terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">11. Termination</h2>
                <p>
                  We may terminate or suspend your account at any time for violations of these terms.
                  You may delete your account at any time through the Settings page.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-white mb-3">12. Contact</h2>
                <p>
                  For questions about these Terms, please contact us at{' '}
                  <a href="mailto:support@dartscheduler.com" className="text-[#1111d4] hover:underline">
                    support@dartscheduler.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
